import { ImmunisationClearCertificate as BaseImmunisationCertificate } from "@teamprevent/common/immunisation/components/ImmunisationClearCertificate";

import { connect } from "react-redux";

import { ApplicationState } from "../applicationState";

import { routeIdSelector as customerIdSelector } from "../crud/customer/selectors";

import { routeIdSelector as employeeRecordIdSelector } from "../crud/employeeRecord/selectors";

import { routeIdSelector as ohCaseIdSelector } from "../crud/ohCase/selectors";

import { taskIdSelector } from "../task/selectors";

import { immunisationOhCaseApi } from "./immunisationOhCaseApi";

const mapStateToProps = (state: ApplicationState) => {
    const customerId = customerIdSelector(state);
    const employeeRecordId = employeeRecordIdSelector(state);
    const ohCaseId = ohCaseIdSelector(state);
    const taskId = taskIdSelector(state);
    return { loadCertificateDetails: () => immunisationOhCaseApi.getImmunisationClearCertificateDetails(customerId, employeeRecordId, ohCaseId, taskId) };
};

const ImmunisationClearCertificate = connect(mapStateToProps)(BaseImmunisationCertificate);

export { ImmunisationClearCertificate };
